import React from 'react';
import './MeetingsConfigurationStep.scss';
import {useTranslation} from "react-i18next";
import {Text} from "../../../index";
import {useSelector} from "react-redux";

const MeetingsConfigurationStep = () => {
    const {t} = useTranslation();
    const googleToken = useSelector(state => state.userCalendars?.googleToken);
    const outlookToken = useSelector(state => state.userCalendars.outlookInfo?.token?.access_token);
    const isCalendar = googleToken || outlookToken;

    const getTitle = () => {
        if (isCalendar) {
            return ''
        }
        return t('meetings_configuration_step_title')
    }

    const getFooterText = () => {
        if (isCalendar) {
            return t('meetings_configuration_step_footer_1')
        }
        return  t('meetings_configuration_step_footer_2')
    }


    return (
        <div className="meeting-step">
            <Text size="f16" font="book" color="black">{getTitle()}</Text>
            <ul>
                <li>
                    {t('meetings_configuration_step_text_1')}
                </li>
                <li>
                    {t('meetings_configuration_step_text_2')}
                </li>
                <li>
                    {t('meetings_configuration_step_text_3')}
                </li>
            </ul>
            <Text size="f16" font="book" color="#9898A6">{getFooterText()}</Text>
        </div>
    );
};

export default MeetingsConfigurationStep;